import { useState } from 'react';
import { Flex, Link, Tabs, TabsContent, TabsList, TabsTrigger } from '@optiaxiom/react';

import { PageHeader } from '@frontend/components';
import { AppPagePadding } from '@frontend/styles';
import { ToolsManagementPage } from '@frontend/types';

import { ToolSearchInput } from './ToolSearchInput';
import { AddToolsRegistryForm, ToolsRegistryTab } from './ToolsRegistry';
import { ToolsTab } from './ToolsTab';

export function ToolsManagement() {
  const [filterText, setFilterText] = useState('');

  const [activePage, setActivePage] = useState<ToolsManagementPage>('tools');

  if (activePage === 'registry-form') {
    return <AddToolsRegistryForm setActivePage={setActivePage} />;
  }
  return (
    <Flex className={AppPagePadding} gap="24">
      <PageHeader
        title="Tools"
        headingText={
          <>
            Extend Opal&apos;s capabilities with connections across systems and services.{' '}
            <Link
              external
              href="https://support.optimizely.com/hc/en-us/sections/39340042035981-Tools"
            >
              Learn more.
            </Link>
          </>
        }
      />

      <ToolSearchInput
        filterText={filterText}
        handleFilterChange={setFilterText}
        onClickAddToolRegistry={() => setActivePage('registry-form')}
      />
      <Flex w="full">
        <Tabs
          onValueChange={value => setActivePage(value as ToolsManagementPage)}
          value={activePage}
        >
          <TabsList>
            <TabsTrigger value="tools">Tools</TabsTrigger>
            <TabsTrigger value="tools-registries">Registries</TabsTrigger>
          </TabsList>

          <TabsContent py="16" value="tools">
            <ToolsTab filterText={filterText} />
          </TabsContent>

          <TabsContent py="16" value="tools-registries">
            <ToolsRegistryTab filterText={filterText} />
          </TabsContent>
        </Tabs>
      </Flex>
    </Flex>
  );
}
